const GAME_SPEEDS = {
    STARTING: 750,
};

export default GAME_SPEEDS;
